export default __webpack_public_path__ + "static/media/keyvis_players_mob.c6dc4f33.png";